var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 280,
    viewBox: "0 0 442 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2305_19892)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.234375,
    width: 446,
    height: 281.452,
    rx: 19.4105,
    fill: "#85C1E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-13.5933 204.017C-3.89657 179.317 -3.08117 149.745 13.7414 130.63C30.5175 111.568 54.6072 108.029 76.5675 101.571C97.5221 95.4094 117.875 96.8144 139.062 93.7781C171.504 89.1289 212.761 53.3496 234.703 78.9094C256.489 104.288 221.5 153.389 222.623 191.118C223.494 220.377 249.969 244.812 240.482 273.093C230.863 301.771 198.046 307.776 177.069 326.922C159.292 343.147 147.165 368.921 126.301 377.31C105.251 385.773 84.3906 375.699 63.2321 372.694C39.669 369.346 14.0162 373.198 -5.38929 358.601C-26.3327 342.847 -46.7301 319.134 -48.3416 288.768C-49.9566 258.337 -24.9536 232.954 -13.5933 204.017Z",
    fill: "white",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2319 -31.8208C78.5732 -29.273 104.014 -35.4466 124.24 -25.5121C144.411 -15.6052 153.025 4.15765 163.637 21.4228C173.763 37.8973 177.288 55.6151 184.8 73.0147C196.301 99.6569 236.429 126.599 219.698 151.287C203.085 175.8 153.037 157.308 121.082 167.033C96.3009 174.575 81.5826 202.875 55.2319 201.339C28.5121 199.781 15.7662 173.133 -5.45196 159.656C-23.4328 148.235 -48.2554 143.86 -60.262 127.98C-72.3754 111.959 -68.6162 91.7932 -70.9614 73.0147C-73.5731 52.1019 -82.817 31.0761 -74.8582 11.1027C-66.2687 -10.4536 -50.7557 -33.3926 -25.2016 -41.8242C0.40757 -50.274 27.886 -34.8057 55.2319 -31.8208Z",
    fill: "white",
    fillOpacity: 0.37
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2305_19892"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.234375,
    width: 446,
    height: 281.452,
    rx: 19.4105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard4);
export default __webpack_public_path__ + "static/media/card4.40823e623a95887d45403c85c8956f7d.svg";
export { ForwardRef as ReactComponent };